module.exports = "small.text-muted {\n  color: #a81512 !important;\n  margin-top: -4px;\n  margin-bottom: 5px;\n  font-size: 10px;\n  line-height: 10px;\n  margin-left: 0.375rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/field-errors.component.scss
// module id = ./src/app/shared/field-errors.component.scss
// module chunks = main